var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnseatgreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6273 14.7006L14.6407 15.7139L16.6673 13.6873M12.106 9.24658C12.0393 9.23992 11.9593 9.23992 11.886 9.24658C11.1208 9.2206 10.3957 8.89781 9.86441 8.34656C9.33306 7.79531 9.03715 7.05889 9.03932 6.29325C9.03827 5.90481 9.11389 5.51997 9.26185 5.16081C9.40982 4.80164 9.62721 4.47521 9.90158 4.20023C10.1759 3.92524 10.5019 3.70711 10.8607 3.55834C11.2195 3.40957 11.6042 3.33308 11.9927 3.33325C13.626 3.33325 14.9527 4.65992 14.9527 6.29325C14.9527 7.89325 13.686 9.19325 12.106 9.24658Z",
    stroke: "#05603A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9934 16.54C10.78 16.54 9.57336 16.2333 8.65336 15.62C7.04003 14.54 7.04003 12.78 8.65336 11.7066C10.4867 10.48 13.4934 10.48 15.3267 11.7066",
    stroke: "#12B76A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnseatgreen);
export default __webpack_public_path__ + "static/media/onseatgreen.e27e3832d26996ede54a9eb5e1aff6c2.svg";
export { ForwardRef as ReactComponent };